import { createFileRoute } from '@tanstack/react-router'
import AntiPhishingSetup from '@/features/anti-phishing-setup/AntiPhishingSetup'

export const Route = createFileRoute('/_ems/emsi/safari')({
  component: AntiPhishingSetup,
})
